import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const getActiveMaterials = (params = {}) => axios.get(`${API_URLS.MATERIAL}/suggest`, { params });
